module.exports = __webpack_public_path__ + "img/camara-fria.a78fc196.png";